import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import List from '../../Symbols/List';
import columnize from './styles';

export default function AreaList({ type, list }) {
	return <List className={columnize}>
		{list.map(item => (
			<li key={item.id}>
				<Link to={`/${type}/${item.id}`}>{item.name}</Link>
			</li>
		))}
	</List>;
}

AreaList.propTypes = {
	list: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.number
		]).isRequired,
		name: PropTypes.string.isRequired
	})),
	type: PropTypes.string.isRequired
}

export class AreaListOrdered extends React.Component {

	static sort(a, b) {
		if (typeof a.name.localeCompare === 'function') {
			return a.name.localeCompare(b.name, 'cs');
		}

		if (a.name < b.name) return -1;
		if (a.name > b.name) return 1;
		return 0;
	}

	shouldComponentUpdate(nextProps) {
		return this.props.list !== nextProps.list;
	}

	render() {
		// Sorting in render function is safe when using shouldComponentUpdate lifecycle
		const list = this.props.list.slice().sort(AreaListOrdered.sort);

		return <AreaList type={this.props.type} list={list} />
	}

}
